/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Version_LabelInputs */

const en_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

const fr_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

const de_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

const it_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versione ${i?.version}`)
};

const ru_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Версия ${i?.version}`)
};

const es_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versión ${i?.version}`)
};

const zh_cn2_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`版本 ${i?.version}`)
};

const ja_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`バージョン ${i?.version}`)
};

const hi_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`संस्करण ${i?.version}`)
};

const pt_pt2_version_label = /** @type {(inputs: Version_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão ${i?.version}`)
};

/**
* | output |
* | --- |
* | "Version {version}" |
*
* @param {Version_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const version_label = /** @type {((inputs: Version_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Version_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_version_label(inputs)
	if (locale === "de") return de_version_label(inputs)
	if (locale === "it") return it_version_label(inputs)
	if (locale === "ru") return ru_version_label(inputs)
	if (locale === "es") return es_version_label(inputs)
	if (locale === "zh-CN") return zh_cn2_version_label(inputs)
	if (locale === "ja") return ja_version_label(inputs)
	if (locale === "hi") return hi_version_label(inputs)
	if (locale === "pt-PT") return pt_pt2_version_label(inputs)
	return en_version_label(inputs)
});